import { useCallback } from 'react';
import { PanelPortal } from '@frontend/panel-engine';
import { useIsCompactMode } from '@frontend/responsiveness';
import { SchedulePulseTrayContent } from '@frontend/schedule';
import { SurfaceHeader } from '@frontend/surface-header';
import { useTopBarShallowStore } from '../../store/use-top-bar-store';
import { labelMap } from '../../utils/label-map';
import { TopBarPanelContent } from '../panels/top-bar-panel-scaffold';

export const SchedulePulsePanel = ({ onClose }: { onClose: () => void }) => {
  const isCompactMode = useIsCompactMode();

  return (
    <PanelPortal id='schedulePulse' width='medium' onClose={onClose}>
      <SurfaceHeader.Root noBorder>
        <SurfaceHeader.Row>
          {isCompactMode && (
            <SurfaceHeader.Start>
              <SurfaceHeader.Icon
                iconName='caret-left'
                onClick={onClose}
                label='Back'
                trackingId='schedule-pulse-back-button'
              />
            </SurfaceHeader.Start>
          )}
          <SurfaceHeader.Title data-testid='tray-header'>{labelMap['schedulePulse']}</SurfaceHeader.Title>
          <SurfaceHeader.Actions>
            {!isCompactMode && (
              <SurfaceHeader.Icon
                iconName='x'
                onClick={onClose}
                label='Close Schedule Pulse Panel'
                trackingId='schedule-pulse-close-panel-button'
              />
            )}
          </SurfaceHeader.Actions>
        </SurfaceHeader.Row>
      </SurfaceHeader.Root>
      <TopBarPanelContent>
        <SchedulePulseTrayContent onClose={onClose} />
      </TopBarPanelContent>
    </PanelPortal>
  );
};

export const SchedulePulsePanelWrapper = () => {
  const { isSchedulePulseOpen, setSchedulePulseOpen } = useTopBarShallowStore(
    'isSchedulePulseOpen',
    'setSchedulePulseOpen'
  );
  const closeSchedulePulse = useCallback(() => setSchedulePulseOpen(false), [setSchedulePulseOpen]);

  if (!isSchedulePulseOpen) {
    return null;
  }
  return <SchedulePulsePanel onClose={closeSchedulePulse} />;
};
